import { getAllMatchPeriods, getPlayedGamesPeriods } from "../../../../../../sports/rules.js";
import GameFactEventDto from "../GameFactEventDto.js";

export class StartDto extends GameFactEventDto {

    constructor(event){
        super(event);
        this.tab = event.tab ??"DEBUT"
        this.detail = {
            ...this.detail,
            title : event.detail?.title || "DEBUT",
            comment : event.detail?.comment,
          };

        // Supprime la propriété si elle existe dans l'objet
        if ('isAutomaticCommentary' in this) {
            delete this.isAutomaticCommentary;
        }
    }

    get comment() {
        return this.detail.comment;
      }

    set comment(value) {
        this.detail.comment = value;
    }

    initTimerPeriod(match){
        super.initTimerPeriod(match)

        this.timer =  0
        this.period = match.period

        const allPeriods = getAllMatchPeriods(match.discipline);
        //TODO OPTA PER 2 - bout de scotch là
        const optaCase = match.discipline!=='handball' && match.discipline!=='basket' && this.detail.period === 2
        let periodModel;

         const allPlayedPeriods = getPlayedGamesPeriods(match.discipline);
         periodModel = [...allPlayedPeriods.values()]
            .find(p => p.matchPeriod === this.detail.period);

        if (optaCase || !periodModel){
            periodModel = [...allPeriods.values()]
                .find(p => p.matchPeriod === (optaCase ? 6 : this.detail.period));
        }

        // let allPlayablePeriods = getPlayedGamesPeriods(match.discipline);
        this.detail.title = ("DEBUT "+ periodModel?.name).toUpperCase()

        if(match.period !== 0){
            this.isEnableTrigger = false
        }
        
    }

    updateDetail(key, value, match) {
        super.updateDetail(key, value)
    }
}